const momentEnUs = {
  parentLocale: "en",
  longDateFormat: {
    "[DM]": "MM/DD",
    "[DDMMYY]": "MM/DD/YY"
  }
};

export default momentEnUs;
